module.exports = __webpack_public_path__ + "img/blufi_hero_bg.3255eb0b.png";